import ReactPaginate from "react-paginate";
import CommonButton from "../../components/ui/CommonButton/CommonButton";
import CommonCard from "../../components/ui/CommonCard/CommonCard";
import classes from "./Users.module.css";
import { useEffect, useState } from "react";
import { MdInfoOutline } from "react-icons/md";
import { IoClose, IoCloseCircleOutline } from "react-icons/io5";
import BankIcon from "../../icons/BankIcon";
import InputField from "../../components/ui/InputField/InputField";
import { useTheme } from "../../context/ThemeContext";
import useWindowDimensions from "../../hooks/getWindowDimensions";
import { RxCaretDown } from "react-icons/rx";
import VerticalDotsIcon from "../../icons/VerticalDotsIcon";
import ActionCard from "../../components/ActionCard/ActionCard";
import AlertDialog from "../../components/ui/AlertDialog/AlertDialog";
import OutlinedButton from "../../components/ui/OutlinedButton/OutlinedButton";
import { env } from "../../constants/env";
import { formatDate } from "../../utilities/functions";
import axios from "axios";
import { toast } from "react-toastify";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa6";
import Table from "../../components/Table/Table";
import { use } from "react";

const users = [
  {
    name: "John Doe",
    email: "jd@gmail.com",
    plan: "Explorer",
    dateJoined: "2024-11-24",
  },
  {
    name: "John Doe",
    email: "jd@gmail.com",
    plan: "Explorer",
    dateJoined: "2024-11-24",
  },
  {
    name: "John Doe",
    email: "jd@gmail.com",
    plan: "Explorer",
    dateJoined: "2024-11-24",
  },
  {
    name: "John Doe",
    email: "jd@gmail.com",
    plan: "Explorer",
    dateJoined: "2024-11-24",
  },
  {
    name: "John Doe",
    email: "jd@gmail.com",
    plan: "Explorer",
    dateJoined: "2024-11-24",
  },
  {
    name: "John Doe",
    email: "jd@gmail.com",
    plan: "Explorer",
    dateJoined: "2024-11-24",
  },
  {
    name: "John Doe",
    email: "jd@gmail.com",
    plan: "Explorer",
    dateJoined: "2024-11-24",
  },
  {
    name: "John Doe",
    email: "jd@gmail.com",
    plan: "Explorer",
    dateJoined: "2024-11-24",
  },
  {
    name: "John Doe",
    email: "jd@gmail.com",
    plan: "Explorer",
    dateJoined: "2024-11-24",
  },
];

const UsersHeader = ({ width }) => {
  return (
    <tr>
      <th>Name</th>
      <th>Email</th>
      <th>Plan</th>
      <th>Date Joined</th>
      <th></th>
    </tr>
  );
};

const UsersRow = ({
  user,
  deleteUser,
  suspendUser,
  reinstateUser,
  cancelUser,
}) => {
  const [showActions, setShowActions] = useState(false);
  const [showDialog, setShowDialog] = useState(false);
  const [action, setAction] = useState("");
  const [confirmAction, setConfirmAction] = useState("");

  console.log("USERS", user.subscription?.planId);

  const handleAction = (action) => {
    setShowActions(false);
    setShowDialog(true);
    setAction(action);
  };

  const handleConfirm = () => {
    if (action === "delete") {
      deleteUser(user._id);
    } else if (action === "suspend") {
      suspendUser(user._id);
    } else if (action === "cancel") {
      cancelUser(user._id);
    }
    setShowDialog(false);
    setConfirmAction(action);
  };

  const handleReinstate = async () => {
    await reinstateUser(user._id);
    setShowActions(false);
  };
  return (
    <>
      <tr>
        <td>{user.name}</td>
        <td>{user.email}</td>
        <td>{user.plan}</td>
        <td>{formatDate(user.dateJoined)}</td>
        <td>
          <div className={classes.actionWrapper}>
            <div
              className={`d-flex align-items-center justify-content-between ${classes.cancelActionWrapper}`}
            >
              <VerticalDotsIcon onClick={() => {}} />
            </div>
          </div>
        </td>
      </tr>
      <AlertDialog
        isOpen={showDialog}
        onClose={() => setShowDialog(false)}
        centerCard={true}
      >
        <div className={classes.cancelContainer}>
          <h5>
            {action === "suspend"
              ? "SUSPEND USER"
              : action === "cancel"
              ? "CANCEL SUBSCRIPTION"
              : "DELETE USER"}
          </h5>
          {action === "suspend" ? (
            <p>
              Are you sure you can to suspend{" "}
              <span>
                {user?.firstName} {user?.lastName}'s
              </span>{" "}
              account? The user will be unable to access the portal until this
              is undone.
            </p>
          ) : action === "cancel" ? (
            <p>
              Are you sure you can to cancel{" "}
              <span>
                {user?.firstName} {user?.lastName}'s{" "}
                {user.subscription?.planId?.planName}
              </span>{" "}
              subscription?
            </p>
          ) : (
            <p>
              Are you sure you can to delete{" "}
              <span>
                {user?.firstName} {user?.lastName}'s
              </span>{" "}
              account? The user will no longer have access to the portal.
            </p>
          )}
        </div>
        <div className="d-flex align-items-center gap-2">
          <OutlinedButton
            buttonText="Cancel"
            onClick={() => setShowDialog(false)}
          />
          <CommonButton title="Confirm" onClick={handleConfirm} />
        </div>
      </AlertDialog>
    </>
  );
};

const Users = () => {
  const [users, setUsers] = useState([]);
  const [pageCount, setPageCount] = useState(3);
  const [currentPage, setCurrentPage] = useState(0);
  const [searchTerm, setSearchTerm] = useState("");
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const { darkMode } = useTheme();
  const [showDialog, setShowDialog] = useState();
  const [dialogContent, setDialogContent] = useState(null);
  const [selectedUser, setSelectedUser] = useState(null);
  const [userInfo, setUserInfo] = useState(null);
  const [isSending, setIsSending] = useState(false);
  const [username, setUsername] = useState("");
  const [email, setEmail] = useState("");

  const [limit, setLimit] = useState(10); // default is 10

  const [showTableDialog, setShowTableDialog] = useState(false);

  console.log("SELECTED USER", selectedUser);

  const withDrawalrequest = [
    {
      title: "Account ID",
      value: userInfo?.account?.accountId,
    },
    {
      title: "Stage",
      value: userInfo?.account?.accountType,
    },
    {
      title: "Master password",
      value: userInfo?.account?.masterPassword,
    },
    {
      title: "Investor password",
      value: userInfo?.account?.investorPassword,
    },
  ];

  useEffect(() => {
    if (selectedUser !== null) {
      setUserInfo(users[selectedUser]);
      setUsername(users[selectedUser].name);
      setEmail(users[selectedUser].email);
    }
  }, [selectedUser]);

  const token = localStorage.getItem("token");

  const fetchUsers = async (page = 1, limitValue = limit, search = searchTerm) => {
    try {
      const response = await fetch(
        `${env.apiUrl}/api/user/users?page=${page}&limit=${limitValue}&search=${encodeURIComponent(search)}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      const data = await response.json();
      console.log("DATA", data);
      if (response.ok) {
        setUsers(data.users);
        setPageCount(data.totalPages);
        setCurrentPage(data.currentPage - 1); // react-paginate uses zero-indexed pages
        setLoading(false);
      } else {
        setError(data.message || "Error fetching users");
      }
    } catch (error) {
      setError("Error fetching users");
    }
  };

  useEffect(() => {
    fetchUsers();
  }, []);

  // Handle delete user
  const deleteUser = async (userId) => {
    // if (window.confirm('Are you sure you want to delete this user?')) {
    try {
      await axios.delete(`${env.apiUrl}/api/user/delete/${userId}`, {
        headers: {
          Authorization: `Bearer ${token}`, // Assuming you're using JWT
        },
      });
      toast.success("User deleted successfully");
      setShowDialog(false);
      fetchUsers(); // Refresh the user list
    } catch (error) {
      console.error("Error deleting user:", error);
      toast.error("Error deleting user");
    }
    // }
  };

  const suspendUser = async (userId) => {
    try {
      const response = await axios.put(
        `${env.apiUrl}/api/user/suspend/${userId}`,
        { status: "suspended" },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      toast.success(response.data.message);
      setShowDialog(false);
      fetchUsers(); // Refresh the user list
    } catch (error) {
      console.error("Error suspending user:", error);
      toast.error("Error suspending user");
    }
  };

  const updateUser = async (userId) => {
    setIsSending(true);

    const token = localStorage.getItem("token"); // Make sure the token is stored in localStorage

    try {
      const response = await fetch(`${env.apiUrl}/api/user/update/${userId}`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({
          username,
          email,
        }),
      });

      const data = await response.json();
      if (response.ok) {
        toast.success("User updated successfully");
        setUsername("");
        setEmail("");
        setShowDialog(false);
        fetchUsers(); // Refresh the user list
      } else {
        toast.error(data.message || "Error updating user credentials");
      }
    } catch (error) {
      toast.error("Error updating user credentials");
    }
    setIsSending(false);
  };

  const reinstateUser = async (userId) => {
    const token = localStorage.getItem("token"); // Get the admin token from localStorage or where it's stored

    try {
      // setLoading(true);

      // Make the API call to reinstate the user
      const response = await axios.put(
        `${env.apiUrl}/api/users/reinstate-user/${userId}`,
        {},
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      toast.success(response.data.message);
      setShowDialog(false);
      fetchUsers();
    } catch (error) {
      toast.error(error.response?.data?.message || "Error reinstating user");
    } finally {
      // setLoading(false);
    }
  };

  // Define the columns to be displayed
  const columns = [
    { key: "name", label: "Name" },
    { key: "email", label: "Email" },
    { key: "plan", label: "Plan" },
    { key: "dateJoined", label: "Date Joined" },
    // "id" is not included here, so it won't be displayed
  ];

  const handlePageClick = (event) => {
    const selectedPage = event.selected + 1; // react-paginate uses 0-based index
    fetchUsers(selectedPage);
  };

  const handleLimitChange = (e) => {
    const newLimit = parseInt(e.target.value);
    setLimit(newLimit);
    fetchUsers(1, newLimit); // always go to first page
  };

   const handleSearchChange = (e) => {
    const search = e.target.value;
    setSearchTerm(search);
    fetchUsers(1, limit, search); // always go to first page
  };

  if (loading) return <div>Loading...</div>;
  if (error) return <div>{error}</div>;

  return (
    <div className={classes.wrapper}>
      {/* <div className="d-flex align-items-center justify-content-center">
        <InputField
          className={classes.searchInput}
          search={true}
          placeholder="Search users"
          onChange={handleSearch}
        />
      </div> */}
      <div className="mt-3">
        <div className="d-flex align-items-center justify-content-between">
          <h3>Users</h3>
          <InputField
            placeholder="Search for user"
            onChange={handleSearchChange}
          />
        </div>
      </div>
      <CommonCard className={`${classes.tableCard} mt-4`}>
        <Table
          data={users}
          dataType={"User"}
          userInfo={() => {
            setShowDialog(true);
            setDialogContent("info");
          }}
          editUser={() => {
            setShowDialog(true);
            setDialogContent("edit");
          }}
          suspendUser={() => {
            setShowDialog(true);
            setDialogContent("suspend");
          }}
          deleteUser={() => {
            setShowDialog(true);
            setDialogContent("delete");
          }}
          columns={columns}
          clickedIndex={(index) => setSelectedUser(index)}
          showDialog={showTableDialog}
          setShowDialog={(value) => setShowTableDialog(value)}
        />

        <AlertDialog
          isOpen={showDialog}
          onClose={() => setShowDialog(false)}
          centerCard={true}
          titleText={dialogContent === "edit" ? "Edit user" : "Info"}
          showCloseIcon={dialogContent !== "edit"}
          style={{
            left: `calc(50vw - ${
              dialogContent === "edit" ? "130px" : "225px"
            })`,
          }}
          showToSection={
            dialogContent !== "delete" && dialogContent !== "suspend"
          }
        >
          {dialogContent === "info" ? (
            <>
              <div className={`row ${classes.contentSection}`}>
                {withDrawalrequest.map((item, i) => (
                  <div className="col-6 mb-3" key={i}>
                    <div className={classes.titleText}>{item.title}</div>
                    <div
                      className={`${classes.valueText} ${
                        item.value === "Approved"
                          ? classes.successText
                          : item.value === "Declined" && classes.dangerText
                      }`}
                    >
                      {item.value}
                    </div>
                  </div>
                ))}
              </div>
            </>
          ) : (
            <div className={classes.declinedContainer}>
              {dialogContent === "edit" ? (
                <div className="d-flex flex-column gap-3">
                  <input
                    type="text"
                    placeholder="Jane Doe"
                    value={username}
                    onChange={(e) => setUsername(e.target.value)}
                  />
                  <input
                    type="text"
                    placeholder="jdoe@gmail.com"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                  />
                </div>
              ) : (
                <p>{`Are you sure you want to ${
                  dialogContent === "delete" ? "remove" : "suspend"
                } this user? This action cannot be undone`}</p>
              )}
              <div className="row mt-3">
                <div className="col-6">
                  <button
                    className={classes.cancelButton}
                    onClick={() => setShowDialog(false)}
                  >
                    Cancel
                  </button>
                </div>
                <div className="col-6">
                  <button
                    className={`${classes.declineButton} ${
                      dialogContent !== "edit" && classes.deleteButton
                    }`}
                    onClick={() =>
                      dialogContent === "delete"
                        ? deleteUser(userInfo.id)
                        : dialogContent === "suspend"
                        ? suspendUser(userInfo.id)
                        : dialogContent === "edit" && updateUser(userInfo.id)
                    }
                  >
                    {dialogContent === "delete"
                      ? "Remove user"
                      : dialogContent === "suspend"
                      ? "Suspend user"
                      : "Save changes"}
                  </button>
                </div>
              </div>
            </div>
          )}
        </AlertDialog>
        <div className="d-flex justify-content-between align-items-center mt-4">
          {/* Limit Selector */}
          <div className="d-flex align-items-center gap-2 p-2">
            <span>Show:</span>
            <select
              value={limit}
              onChange={handleLimitChange}
              className="form-select"
              style={{ width: "80px" }}
            >
              <option value={10}>10</option>
              <option value={25}>25</option>
              <option value={50}>50</option>
            </select>
            <span>entries</span>
          </div>

          {/* Pagination */}
          <ReactPaginate
            previousLabel={<FaChevronLeft />}
            nextLabel={<FaChevronRight />}
            breakLabel={"..."}
            pageCount={pageCount}
            marginPagesDisplayed={2}
            pageRangeDisplayed={1}
            onPageChange={handlePageClick}
            containerClassName={"pagination"}
            subContainerClassName={"pages pagination"}
            previousLinkClassName={`page-link ${
              currentPage === 0 ? "disabled" : ""
            }`}
            nextLinkClassName={`page-link ${
              currentPage === pageCount - 1 ? "disabled" : ""
            }`}
            activeClassName={"active"}
          />
        </div>
      </CommonCard>
    </div>
  );
};

export default Users;
